export default {
  title: {
    list: '公司文化'
  },
  label: {
    companyCulture: '公司文化',
    cultureBenchmark: '公司文化基准',
    assessmentIntroOne: `本步骤目的在于识别并确认您的公司文化。公司文化反映着一家公司如何进行日常运营，公司员工关心什么、如何在一起工作、员工有何种行为标准以及如何在公司中取得成功等问题。
    您也可以把它看作是公司的性格。通过该步骤您可以为公司进行文化定位，并据此对申请者进行筛选，以快速判断出谁是最适合公司文化的申请者。`,
    assessmentIntroTwo: `为完成这一步骤，请根据您公司理想中的工作环境，拖拽每个价值观从左边的区域到对应的右边3个区域，分别为重要，不重要，中立。
    一旦所有价值观都放入对应的区域中，您需要再选择其中最重要的3点和最不重要的3点。请注意，每个价值观的所在的位置都很重要，这能帮助您筛选出与您的公司文化最为匹配的申请者。`,
    unimportantUpperCase: '不 重 要',
    neutralUpperCase: '中 立',
    importantUpperCase: '重 要'
  },
  message: {
    cultureBenchmarkHasSuccessfully: '公司文化基准已经成功更新',
    containerAlreadyFull: '该组别已满，请拖拽到其他组别。',
    selectBeyondTheLimit: '只能选择3个选项，再次点击词条可取消选择。'
  },
  button: {
    back: '返回',
    close: '关闭'
  }
}
